module.exports = __webpack_public_path__ + "img/0012.e071ee82.jpg";